"use strict";
/**
 * @license
 * Copyright 2022 SOUTHWORKS UK LTD All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/southworks/codeverter/blob/main/LICENSE
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.File = void 0;
const typescript_1 = require("typescript");
const element_1 = require("./element");
const path_1 = require("path");
const variable_helper_1 = require("./helpers/variable-helper");
class File extends element_1.Element {
    constructor(params) {
        super(params);
        this.sourceFile = params.sourceFile;
        this.typeChecker = params.typeChecker;
        this.kind = "file";
    }
    addClass(node) {
        this.addElement("class", node);
    }
    addFunction(node) {
        this.addElement("function", node);
    }
    addEnumerate(node) {
        this.addElement("enum", node);
    }
    addInterface(node) {
        this.addElement("interface", node);
    }
    addDeclaration(node) {
        (0, variable_helper_1.addVaribles)(node, (k, n) => this.addElement(k, n));
    }
    visitNode(node) {
        if ((0, typescript_1.isClassDeclaration)(node)) {
            this.addClass(node);
        }
        else if ((0, typescript_1.isFunctionDeclaration)(node)) {
            this.addFunction(node);
        }
        else if ((0, typescript_1.isVariableDeclarationList)(node)) {
            this.addDeclaration(node);
        }
        else if ((0, typescript_1.isEnumDeclaration)(node)) {
            this.addEnumerate(node);
        }
        else if ((0, typescript_1.isInterfaceDeclaration)(node)) {
            this.addInterface(node);
        }
        else {
            node.forEachChild(child => this.visitNode(child));
        }
    }
    getSourceFile() {
        return this.sourceFile;
    }
    getTypeChecker() {
        return this.typeChecker;
    }
    parse(node) {
        this.name = (0, path_1.basename)(node.fileName).replace((0, path_1.extname)(node.fileName), "");
        this.visitNode(node);
    }
    get classes() {
        return this.getValues("class");
    }
    get interfaces() {
        return this.getValues("interface");
    }
    get variables() {
        return this.getValues("variable");
    }
    get constants() {
        return this.getValues("constant");
    }
    get functions() {
        return this.getValues("function");
    }
    get enumerates() {
        return this.getValues("enum");
    }
}
exports.File = File;
